import type { MutationHookOptions } from "@apollo/client"
import { useMutation } from "@apollo/client"
import mutation from "@/v2-backoffice-client/uptime/configCategory/delete/uptime.configCategory.delete.mutation.gql"
import { UPTIME_CONFIG_REFETCH_QUERIES } from "@/v2-backoffice-client/uptime/config/uptime.config.query"
import type {
  UptimeConfigCategoryDeleteMutation,
  UptimeConfigCategoryDeleteMutationVariables,
} from "@/v2-backoffice-client/uptime/configCategory/delete/__types__/uptime.configCategory.delete.mutation"

type Options = MutationHookOptions<
  UptimeConfigCategoryDeleteMutation,
  UptimeConfigCategoryDeleteMutationVariables
>

export function useUptimeConfigCategoryDeleteMutation(options?: Options) {
  return useMutation<
    UptimeConfigCategoryDeleteMutation,
    UptimeConfigCategoryDeleteMutationVariables
  >(mutation, {
    refetchQueries: [...UPTIME_CONFIG_REFETCH_QUERIES],
    awaitRefetchQueries: true,
    ...options,
  })
}
